import React, { Ref } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Currency from 'components/currency';
import IconBag from 'components/icons/bag';
import { useUIContext } from 'state/ui';

import { FloatingLink } from './styled';

const IconBagSmall = styled(IconBag)`
  fill: ${Styles.color.primary};
  height: 1.125rem;
  margin: 0 0.5rem 0 0;
  width: 1.4rem;
`;

export interface ICheckoutButtonLink {
  ref: Ref<HTMLAnchorElement>;
  amount: number;
  to: string;
  logMobileCheckoutEvent: () => void;
}

const CheckoutButtonLink = ({ amount, to, logMobileCheckoutEvent, ref }: ICheckoutButtonLink) => {
  const { appFooterDimensions, bottomServiceDimensions } = useUIContext();

  const { formatMessage } = useIntl();

  return (
    <FloatingLink
      $bottomInset={appFooterDimensions.height + bottomServiceDimensions.height}
      data-testid="cart-button-mobile"
      aria-label={formatMessage({ id: 'checkout' })}
      onClick={logMobileCheckoutEvent}
      to={to}
      ref={ref}
    >
      <IconBagSmall />
      <Currency amount={amount} />
    </FloatingLink>
  );
};

export default CheckoutButtonLink;
